module.exports = "<div class=\"row banner-wrap\">\r\n    <ng-container *ngFor=\"let banner of banners;let i=index\" >\r\n        <div class=\"col-md-4\" *ngIf=\"i>=2 && i<5\">\r\n            <a target=\"_blank\" href=\"{{banner.url}}\" class=\"inline-block banner-pic\">\r\n                <img *ngIf=\"banner.images[0]\" src=\"{{banner.images[0].imageUrl}}\" alt=\"{{banner.title}}\" title=\"{{banner.title}}\">\r\n            </a>\r\n        </div>\r\n    </ng-container>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/banner/banner.component.html
// module id = ./src/app/core/banner/banner.component.html
// module chunks = dashboard.module